export default "__VITE_ASSET__$es$16Uh__"